
import Vue from "vue";
import { Component } from "vue-property-decorator";
import BrandPaletteGenerator from "./BrandPaletteGenerator.vue";
import { singularityStore } from "@/store/store";
import { NamedColorPalette } from "@/types/singularity/brand";
import IconButtonShuffle from "../../components/IconButtonShuffle.vue";
import Icon from "@/components/UI/Icon.vue";
import {
  shufflePalettes,
  shufflePrimaryPalette,
  addSecondaryPalette,
  saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings
} from "@/lib/singularity/brand/colors/palettes";
import TogglePanel from "../../components/TogglePanel.vue";
import { logEvent } from "@/util/tracking";
import { breakdanceUndo } from "@/lib/undo/undo";

@Component({
  components: {
    BrandPaletteGenerator,
    IconButtonShuffle,
    Icon,
    TogglePanel
  }
})
export default class BrandManageColors extends Vue {
  get brand() {
    return singularityStore.brand;
  }

  get isPanelOpen() {
    return singularityStore.brandPanelState?.openedPanel === "color";
  }

  updatePrimaryPalette(palette: NamedColorPalette) {
    breakdanceUndo.transaction(() => {
      palette.primary = true;
      singularityStore.setPalette({ type: "primary", palette });
      saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings();
    }, "Updated primary color");
    logEvent("FutureLayer Brand: Primary Palette Updated", { type: "primary" });
  }

  updateSecondaryPalette(index: number, palette: NamedColorPalette) {
    breakdanceUndo.transaction(() => {
      singularityStore.updateSecondaryPalette({ index, palette });
      saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings();
    }, "Updated secondary color");
    logEvent("FutureLayer Brand: Primary Palette Updated", {
      type: "secondary"
    });
  }

  removeSecondaryPalette(index: number) {
    breakdanceUndo.transaction(() => {
      singularityStore.removeSecondaryPalette(index);
      saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings();
    }, "Removed secondary color");
  }

  shuffle() {
    shufflePalettes();
    logEvent("FutureLayer Brand: Colors Shuffled");
  }

  addPalette(index?: number) {
    breakdanceUndo.transaction(() => {
      if (!this.brand.color.primary) {
        shufflePrimaryPalette();
      } else {
        addSecondaryPalette(index);
      }
      saveBrandColorsAsGlobalColorsAndUpdateGlobalSettings();
    }, "Added color palette");
  }
}
